import React from "react";
import Marquee from "react-fast-marquee";

const items = [
  "WhatsApp Business API",
  "HubSpot",
  "Zoho CRM",
  "Pipedrive",
  "Calendly",
  "Google Calendar",
  "Google Sheets",
  "Salesforce",
  "Zapier",
];

export const LogoMarquee = () => (
  <section className="border-y border-silver-300/50 bg-white py-8" data-testid="logo-marquee">
    <p className="mb-6 text-center text-xs font-bold uppercase tracking-[0.25em] text-silver-500">
      Plugs into the stack you already run on
    </p>
    <Marquee speed={32} gradient gradientColor="#FFFFFF" gradientWidth={120} pauseOnHover>
      {items.map((it) => (
        <span
          key={it}
          className="mx-10 font-display text-2xl font-bold tracking-tight text-silver-500 transition-colors hover:text-charcoal sm:text-3xl"
        >
          {it}
        </span>
      ))}
    </Marquee>
  </section>
);

export default LogoMarquee;
